const ITEMS = [
  "Market Opportunity Intelligence",
  "Target Account Identification",
  "Decision-Maker Research",
  "Commercial Market Intelligence",
  "Pipeline Enrichment",
  "Business Development Advisory",
];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="px-8 font-mono text-xs uppercase tracking-[0.35em] text-slate-500">
            {item}
          </span>
          <span className="h-1 w-1 rounded-full bg-gold/60" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-navy-light/40 py-5"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
